import React, { useState, useEffect } from 'react';

export default function Clock() {
  const [times, setTimes] = useState({});

  useEffect(() => {
    const updateTimes = () => {
      const now = new Date();
      setTimes({
        paris: now.toLocaleString('fr-FR', { timeZone: 'Europe/Paris' }),
        newyork: now.toLocaleString('en-US', { timeZone: 'America/New_York' }),
        tokyo: now.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }),
        dubai: now.toLocaleString('ar-AE', { timeZone: 'Asia/Dubai' }),
      });
    };

    updateTimes();
    const interval = setInterval(updateTimes, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h1>🕐 Horloge Mondiale</h1>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div style={{ border: '2px solid blue', padding: '10px' }}>
          <h2>🇫🇷 Paris</h2>
          <p style={{ fontSize: '24px' }}>{times.paris}</p>
        </div>
        <div style={{ border: '2px solid red', padding: '10px' }}>
          <h2>🇺🇸 New York</h2>
          <p style={{ fontSize: '24px' }}>{times.newyork}</p>
        </div>
        <div style={{ border: '2px solid orange', padding: '10px' }}>
          <h2>🇯🇵 Tokyo</h2>
          <p style={{ fontSize: '24px' }}>{times.tokyo}</p>
        </div>
        <div style={{ border: '2px solid green', padding: '10px' }}>
          <h2>🇦🇪 Dubai</h2>
          <p style={{ fontSize: '24px' }}>{times.dubai}</p>
        </div>
      </div>
    </div>
  );
}
